export const FIND_CATEGORY = `
  query FindCategories($filter: CategoryFilter) {
  findCategories(filter: $filter) {
    items {
      id
      name
    }
  }
}
`;
